export const symbolUrl = (url: string) => (url.indexOf('?') >= 0 ? '&' : '?');
